const styles = (theme) => ({
  root:{
    padding:'32px',
  }
})

export default styles